import React, { Component } from "react";
import PropTypes from "prop-types";
// import get from "lodash/fp/get";

import styles from "./index.module.css";
// eslint-disable-next-line import/default
import highchartsConfigurator from "../../utils/highchartsConfigurator";
import RHCharts from "../ReactHighcharts/ReactHighcharts";

let Highcharts;
let ReactHighcharts;

// Default and override styles
import "./themeDefault.css";
import "./themeAtomico.css";

class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      HighchartEl: "div", // A placeholder element for server rendering
      config: null, // will be a valid Highcharts config after mounting
      chartReady: false,
      errorFound: false
    };

    this.onChartReady = this.onChartReady.bind(this);
  }

  getConfig() {
    const options = Object.assign(
      {},
      {
        disableDataLabels: this.props.disableDataLabels,
        title: this.props.title,
        type: this.props.type,
        yAxisLabel: this.props.yAxisLabel,
        yAxisLabel2: this.props.yAxisLabel2,
        suffix: this.props.suffix,
        prefix: this.props.prefix,
        stacking: this.props.stacking,
        groups: [this.props.group]
      }
    );
    // We only receive one group, but the configurator expects an array of
    // groups. We pass in a one element array of groups and the id of that
    // group as the 'selected' group.
    const selectedGroupId = this.props.group.id;
    return highchartsConfigurator.getConfig(options, selectedGroupId);
  }

  componentDidMount() {
    // Setup highcharts now that we're definitely running in the browser
    // Specifically import /js/highcharts to enable CSS-based styling
    // See: https://www.highcharts.com/docs/chart-design-and-style/style-by-css
    Highcharts = require("highcharts/js/highcharts");
    ReactHighcharts = RHCharts.withHighcharts(Highcharts);

    // The `lang` attribute is global and can't be set within the config...
    Highcharts.setOptions({
      lang: {
        thousandsSep: ","
      }
    });

    window.setTimeout(() => {
      this.setState({
        config: this.getConfig(),
        HighchartEl: ReactHighcharts
      });
    }, 200);
  }

  /**
   * Override theme CSS to hide or show the y axis line based on the yAxisLabel
   * prop. We're using Highcharts in styled mode so can't change this via the
   * Highcharts api.
   */
  componentDidUpdate(prevProps) {
    // const chartRef = this.chartRef;
    // const yAxisLabel = this.props.yAxisLabel;
    // if (chartRef) {
    //   const axisLine = get(".chart.yAxis[0].axisLine", chartRef);
    //   if (axisLine) {
    //     // not all charts have an axisLine
    //     chartRef.chart.yAxis[0].axisLine.element.style.strokeWidth = yAxisLabel
    //       ? 1
    //       : 0;
    //   }
    // }
    if (prevProps.group !== this.props.group) {
      this.setState({ config: this.getConfig() });
    }
  }

  componentDidCatch(/*error , info*/) {
    this.setState({ errorFound: true });
    // console.log("Error found", error, info);
  }

  onChartReady() {
    const { chartReady } = this.state;
    if (!chartReady) {
      this.setState({ chartReady: true });
    }
  }

  errorMessage() {
    return (
      <p style={{ color: "black", padding: "10px" }}>
        There was an error displaying this chart.
      </p>
    );
  }

  render() {
    const { children } = this.props;
    const { HighchartEl, config, chartReady, errorFound } = this.state;
    // React complains if we pass the callback prop to our placeholder div
    // Only add it to chartProps once we have a real Highcharts element
    const chartProps = { config, ref: chart => (this.chartRef = chart) };
    if (typeof HighchartEl === "function")
      chartProps.callback = this.onChartReady;

    return (
      <div className={styles.root}>
        {errorFound ? (
          this.errorMessage()
        ) : (
          <div
            className={
              chartReady ? styles.chartWrapperReady : styles.chartWrapper
            }
          >
            <HighchartEl {...chartProps} />
          </div>
        )}
        <div className={styles.footer}>{children}</div>
      </div>
    );
  }
}

Chart.defaultProps = {
  skipTitle: false,
  type: "column",
  stacking: false,
  yAxisLabel: "",
  yAxisLabel2: "",
  prefix: "",
  suffix: ""
};

Chart.propTypes = {
  disableDataLabels: PropTypes.bool,
  title: PropTypes.string,
  skipTitle: PropTypes.bool,
  type: PropTypes.oneOf(["column", "bar", "line", "pie", "column_line"]),
  stacking: PropTypes.bool,
  yAxisLabel: PropTypes.string,
  yAxisLabel2: PropTypes.string,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  onDownloadClick: PropTypes.func,
  // Highcharts data
  group: PropTypes.shape({
    id: PropTypes.number,
    categories: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        data: PropTypes.array // numbers or objects
      })
    )
  })
};

export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart/index.js